import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import DataTable from '../../components/tables/DataTable';
import StatusBadge from '../../components/StatusBadge';
import { getFulfillment } from '../../utils/queries';

export default function FulfillmentDetail() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [fulfillment, setFulfillment] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getFulfillment(id).then((result) => {
			if (result?.success) setFulfillment(result.data);
			setLoading(false);
		});
	}, [id]);

	if (loading) {
		return <div className='py-8 pr-8 text-sm text-gray-400'>Loading...</div>;
	}

	if (!fulfillment) {
		return (
			<div className='py-8 pr-8'>
				<p className='text-sm text-gray-500'>Fulfillment not found.</p>
				<button type='button' className='btn-secondary mt-4' onClick={() => navigate('/fulfillments')}>
					Back to All Fulfillments
				</button>
			</div>
		);
	}

	const lineItemColumns = [
		{ key: 'title', header: 'Item' },
		{ key: 'product_number', header: 'Product #' },
		{ key: 'quantity_shipped', header: 'Qty Shipped' },
	];

	return (
		<div className='py-8 pr-8 max-w-3xl'>
			<button
				type='button'
				className='text-sm text-gray-500 hover:text-black mb-2'
				onClick={() => navigate('/fulfillments')}
			>
				&larr; All Fulfillments
			</button>
			<div className='flex items-center gap-3 mb-1'>
				<h1 className='text-2xl font-light tracking-tight'>
					<Link to={`/orders/${fulfillment.order_id}`} className='hover:underline'>
						{fulfillment.order_number}
					</Link>
				</h1>
				<StatusBadge status='shipped' text={fulfillment.status} />
			</div>

			<dl className='text-sm space-y-1 mb-8 max-w-md'>
				<div className='flex justify-between'><dt className='text-gray-500'>Tracking Number</dt><dd>{fulfillment.tracking_number || '-'}</dd></div>
				<div className='flex justify-between'>
					<dt className='text-gray-500'>Tracking Link</dt>
					<dd>
						{fulfillment.tracking_link ? (
							<a href={fulfillment.tracking_link} target='_blank' rel='noreferrer' className='text-black hover:underline'>
								Track shipment
							</a>
						) : (
							'-'
						)}
					</dd>
				</div>
				<div className='flex justify-between'><dt className='text-gray-500'>Shipped Status</dt><dd>{fulfillment.shipping_lines_source || '-'}</dd></div>
				<div className='flex justify-between'><dt className='text-gray-500'>Shipped At</dt><dd>{fulfillment.shipped_at ? new Date(fulfillment.shipped_at).toLocaleString() : '-'}</dd></div>
				<div className='flex justify-between'><dt className='text-gray-500'>ERP Shipment ID</dt><dd>{fulfillment.erp_shipment_id || '-'}</dd></div>
			</dl>

			<h2 className='text-base font-medium mb-3'>Line Items</h2>
			<DataTable columns={lineItemColumns} data={fulfillment.line_items} emptyHeading='No line items' />
		</div>
	);
}
